export class ValidationCriteria {
  evaluateCriteria(input, criteria) {
    switch (criteria.type) {
      case 'checked_required': {
        return input.checked;
      }
      case 'string_required': {
        // Need to create a new string so as to trim without problems
        let value = '' + input.value;
        return value.trim().length > 0;
      }
      case 'number_min': {
        let value = input.value;
        if (typeof value !== 'number') {
          value = Number.parseInt(value, 10);
        }
        return value >= criteria.min;
      }
      case 'number_max': {
        let value = input.value;
        if (typeof value !== 'number') {
          value = Number.parseInt(value, 10);
        }
        return value <= criteria.max;
      }
      case 'number_negative': {
        let value = input.value;
        if (typeof value !== 'number') {
          value = Number.parseInt(value, 10);
        }
        return value >= 0;
      }
      case 'default_valid': {
        return input.validity.valid
      }
      case 'regex_pattern': {
        let value = input.value;
        return value.match(criteria.pattern) !== null;
      }
      case 'email_pattern': {
        let value = input.value;
        return value.match('^[a-zA-Z0-9.!#$%&’*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)*$') !== null;
      }
      case 'px_left_to_pay': {
        let not_payed = document.querySelector('#paid-off_no').checked;
        
        if (not_payed) {
          return input.validity.valid
        }
        
        return true;
      }
      case 'number_required': {
        let value = input.value;
        return !isNaN(value);
      }
      case 'string_max_length': {
        // Need to create a new string so as to trim without problems
        let value = '' + input.value;
        return value.length <= criteria.max;
      }
      case 'string_min_length_or_empty': {
        // Need to create a new string so as to trim without problems
        let value = '' + input.value;
        return value.trim().length == 0 || value.trim().length >= criteria.min;
      }
      case 'string_min_length': {
        // Need to create a new string so as to trim without problems
        let value = '' + input.value;
        return value.trim().length >= criteria.min;
      }
      case 'checked': {
        return input.checked;
      }
      case 'selected': {
        return !!input[input.selectedIndex].value;
      }
      // By default assume that the criteria is passed
      default:
        return true;
    }
  }
}
